module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-2",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "bold CharOverride-7"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A few years ago, I watched a prime time television special featuring the president and first lady touring a reporter around the White House. They paused in each room and pointed to a vase, a piece of furniture, a painting, or a sculpture and relayed the history of each object to viewers—where the item came from, what year it was added to the White House collection, and its significance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I had never been particularly interested in the house at 1600 Pennsylvania Avenue, its furnishings, grandeur, or history, yet that night, the story behind each piece drew me in and held me captive.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The following day, I surveyed my own home, room by room. I started in the dining room where a small plank of wood hung on the wall—a crude image of the Virgin Mary cradling Jesus in her arms painted on its surface in muted maroons, burgundies, and golds. My husband and I purchased the piece from a street vendor in Athens, Greece just a few years before. It reminded us of the colorful frescos we had seen painted on walls and ceilings of various churches and religious landmarks throughout the city, and so we bought it as a souvenir—to help us remember the fun we shared as we explored ancient Greek ruins on our first trip abroad.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In the center of our dining room, we had positioned a beefy oak pedestal table under a crystal chandelier. Again, memories flooded my mind. We bought the table from an antique dealer in Byron, Georgia. My in-laws were with us that day, and even though it was scratched and blemished, we fell in love with the craftsman style table. We haggled a little with the dealer and eventually bought the piece at what we considered a steal. Together, the four of us witnessed the table’s grand entrance into our first home—such a happy memory.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I walked into our kitchen and noticed a set of four handmade ceramic canisters my mother had made and given us as a wedding gift. In my mind’s eye, I saw Mom hunched over the raw pieces as she sanded, painted and glazed each canister and lid. She carved her name and the date on the bottom of each piece so we would always remember she had made them for us, but how could we ever forget? And how could I ever forget the moments Mom and I shared working on ceramics together at the kitchen table as I grew up?")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Walking into the guest bedroom, I was greeted by a wooden dresser and chest of drawers. The furniture had belonged to my great-grandparents. In the seventies, someone had painted the pieces an ugly avocado green. I hated the color, but I felt a strong attachment to the heirlooms and vowed to refinish them and restore them to their original glory. I loved the idea of touching and using items my great-grandparents had touched and used.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ten minutes into my journey, I realized that our house—like the White House—brimmed with keepsakes and mementoes. Every piece induced a memory of a person, a place, or a special moment. My husband and I were, and still are, caretakers of these items and others—we are devout memory keepers. And each time we move, we carefully pack our keepsakes, haul them across Georgia, and place them in prominent spots in our new home.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Each day, these items sing memories to me. The crocheted afghan in my upstairs closet sings about my maternal grandmother’s wrinkled hands weaving it into existence. A pinkish, purplish vase hanging in my office hums about how much my in-laws enjoyed shopping at estate sales in areas of Chattanooga known for their old money. An old tin, wind-up toy sings a song of a German Shepherd it once terrorized as it rolled around in a circle beneath the dog’s paws. A large, oak rocker sings a song of my father’s mother rocking while reading letters she received from a lonely hearts club.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In today’s world, our homes are museums of our lives, and we are but curators presiding over dozens of objects that meet the definition of keepsake, memento, heirloom, or souvenir. Whether we display our items in curio cabinets or tuck them away in shoeboxes underneath our beds, the appeal is not in their physical being, but in the stories and memories they represent to each of us.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why do you keep this?” I ask when I visit friends’ homes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And then I listen as the stories and memories pour out. Each keepsake—each story—is unique, yet each reveals a commonality that resonates with all of us and celebrates the shared experience of humanity.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My revelation is simple: everyone has a keepsake, and every keepsake has a story to tell. And so I launched "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Project Keepsake")]), _vm._v("—my quest to collect and publish the stories behind people’s cherished keepsakes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At one point, I considered writing a collection of stories about my own keepsakes and treasures or composing other peoples’ stories myself, but I feared my renditions would lack authenticity and fail to capture the depth and unique perspective of each item. The keepers’ own words convey the feelings and emotions much better than my interpretations could. So, I encouraged others to explore the deep-rooted connections they have to their own keepsakes and mementos and write about them. For those who were hesitant to write their own, I offered to help them, but only after they drafted their story themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Most mornings, I wake to find messages or even better, draft stories, in my inbox. For me, reading the stories is like unwrapping a very personal gift. Through their stories, the contributors allow me to peek into their hearts and souls, and sometimes, like a reflection in a mirror, I see myself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As of today, the collection includes over fifty-five complete stories told in first-person by people with very different backgrounds and writing styles, and several other contributors are in the process of writing and editing their stories. Each story is uplifting. Each is transcendent. Each is beautiful. Each is sacred.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I am proud that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Project Keepsake")]), _vm._v(" provides an outlet to celebrate these very special stories and memories and the very human journeys that connect us all.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("While I have learned many things from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Project Keepsake")]), _vm._v(", one lesson that presents itself over and over again is that all of us keep and hold onto objects that link us to the memories we care most about. We keep things so that we will remember, but somewhere along the way, these keepsakes take on a life of their own and define where we came from, what matters to us, and perhaps most of all, who we are.")]), _vm._v(" "), _c('p', {
    staticClass: "text-right-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Amber Lanier Nagle,"), _c('br'), _vm._v("October 2012")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a2ad97f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectKeepsake61.vue
// module id = 69
// module chunks = 0